const scrollAnimations = () => {
	// From top
	$('.fromBottom').each(function() {
		var controller = new ScrollMagic.Controller()
		// Create a scene for each project
		var blockTween = new TweenMax.from(this, 1, {
			y: '100px',
			opacity: 0,
		})
		new ScrollMagic.Scene({
			triggerElement: this,
			triggerHook: 'onEnter',
		})
			.setTween(blockTween)
			.addTo(controller)
	})
	// From top
	$('.fromTop').each(function() {
		var controller = new ScrollMagic.Controller()
		// Create a scene for each project
		var blockTween = new TweenMax.from(this, 1, {
			y: '-100px',
			opacity: 0,
		})
		new ScrollMagic.Scene({
			triggerElement: this,
			triggerHook: 'onEnter',
		})
			.setTween(blockTween)
			.addTo(controller)
	})
	// From Left
	$('.fromLeft').each(function() {
		var controller = new ScrollMagic.Controller()
		// Create a scene for each project
		var blockTween = new TweenMax.from(this, 1, {
			x: '-100px',
			opacity: 0,
		})
		new ScrollMagic.Scene({
			triggerElement: this,
			triggerHook: 'onEnter',
		})
			.setTween(blockTween)
			.addTo(controller)
	})
	// From Right
	$('.fromRight').each(function() {
		var controller = new ScrollMagic.Controller()
		// Create a scene for each project
		var blockTween = new TweenMax.from(this, 1, {
			x: '100px',
			opacity: 0,
		})
		new ScrollMagic.Scene({
			triggerElement: this,
			triggerHook: 'onEnter',
		})
			.setTween(blockTween)
			.addTo(controller)
	})
	// Scale
	$('.fromScale').each(function() {
		var controller = new ScrollMagic.Controller()
		// Create a scene for each project
		var blockTween = new TweenMax.from(this, 0.6, {
			scaleY: 0.5,
			opacity: 0,
		})
		new ScrollMagic.Scene({
			triggerElement: this,
			triggerHook: 'onEnter',
		})
			.setTween(blockTween)
			.addTo(controller)
	})
	$('.fromScaleLong').each(function() {
		var controller = new ScrollMagic.Controller()
		// Create a scene for each project
		var blockTween = new TweenMax.from(this, 4, {
			scale: 0.25,
			rotation: 45,
			opacity: 0,
		})
		new ScrollMagic.Scene({
			triggerElement: this,
			triggerHook: 'onEnter',
		})
			.setTween(blockTween)
			.addTo(controller)
	})
	// To Scale cover
	$('.scaleCover').each(function() {
		var controller = new ScrollMagic.Controller()
		// Create a scene for each project
		var blockTween = new TweenMax.to(this, 0.75, {
			scale: 0.75,
			opacity: 0,
		})
		new ScrollMagic.Scene({
			triggerElement: '.scaleCoverTrigger',
			triggerHook: 'onCenter',
		})
			.setTween(blockTween)
			.addTo(controller)
	})
}
export { scrollAnimations }
